import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/cards/:membershipGroupCardId/';

interface DTO {
    parkingId: string;
    membershipGroupId: number;
    membershipGroupCardId: number;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipGroupId, membershipGroupCardId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { parkingId, membershipGroupId, membershipGroupCardId }));
};

interface UseMutationOptions extends MutationConfig<MutationFnType> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as DELETE_MEMBERSHIP_GROUP_CARD_RESOURCE, useMutationHook as useDeleteMembershipGroupCard };
export type { DTO as DeleteMembershipGroupCardDTO };
